import './productSupportService.scss';

import ProductSubTitle from '../ProductSubTitle';
import React from 'react';
import SupportServiceTile from './SupportServiceTile';
import iconParts from './picto-pieces-black.png';
import iconQuestions from './picto-warranty-black.png';
import iconServices from './picto-service-clientele-black.png';
import iconTricks from './picto-trucs-black.png';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';

export default function ProductSupportService() {
    const { currentLocale } = usePageLocalization();

    const showIcon = (image: any): JSX.Element => <img src={image} alt='' />;

    return (
        <div className='product-support-service'>
            <ProductSubTitle textKey='support-service-title' />

            <div className='product-support-service-container'>
                <SupportServiceTile
                    titleTextKey='need-help'
                    textKey='need-help-details'
                    urlTextKey='need-help-details-link'
                    url='/contact-us/'
                    image={showIcon(iconServices)}
                />
                <SupportServiceTile
                    titleTextKey='need-parts'
                    textKey='need-parts-details'
                    urlTextKey='need-parts-details-link'
                    url='/archives/'
                    image={showIcon(iconParts)}
                />

                <SupportServiceTile
                    titleTextKey='tips-and-tricks'
                    textKey='tips-and-tricks-details'
                    urlTextKey='tips-and-tricks-link'
                    url='/articles/'
                    image={showIcon(iconTricks)}
                />
                <SupportServiceTile
                    titleTextKey='warranty'
                    textKey='warranty-details'
                    urlTextKey='warranty-link'
                    url={currentLocale == 'fr_CA' ? '/garantie/' : '/warranty/'}
                    image={showIcon(iconQuestions)}
                />
            </div>
        </div>
    );
}
